export default __webpack_public_path__ + "static/media/commonmistakes@3x.db7ae3a8.jpg";